import { useAction, useAtom } from "@reatom/npm-react";
import { useCallback } from "react";

import { PoizonOrderFilter } from "../../components/PoizonOrderFilter/PoizonOrderFilter";
import {
  PoizonFilterFormProps,
  poizonFilterAtom,
  setPoizonFilterWithDebounceAction,
} from "../../store/atoms/poizonFilterAtom";

export const PoizonOrderFilterWidget = () => {
  const [filter] = useAtom(poizonFilterAtom);
  const setFilter = useAction(setPoizonFilterWithDebounceAction);
  const onChange = useCallback(
    (newValue: PoizonFilterFormProps) => setFilter(newValue),
    [setFilter],
  );
  return <PoizonOrderFilter onChange={onChange} defaultValue={filter} />;
};
